import ProductForm from "../components/ProductEditForm";
export default function ProductDetail(props) {
  return (
    <ProductForm action="detail" />
  );
}
